export default {
  props: {
    placeholder: {
      type: String,
      default: 'Pick date'
    },
    inputClass: {
      type: [Object, Array],
      default: function() {
        return {}
      }
    },
    value: String
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-datepicker/src/BasicInput.js
// module id = 37
// module chunks = 0